import React from 'react';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import { Slot } from 'react-slot-fill';
import get from 'lodash.get';


const NoSlot = compose(
    connect(({ locationHistory }) => ({
        locationHistory,
    }), {
        replace,
    }),
    lifecycle({
        componentDidMount() {
            const history = get(this.props.locationHistory, 'pathname', null);
            if (history && history !== '/more-info') {
                this.props.replace(history);
            } else {
                this.props.replace('/');
            }
        },
    }),
)(() => null);

const MoreInfoPage = props => [
    <Slot name="Dashboard" key="dashboard" />,
    <Slot name="modal-more-info" key="more-info">
        {slots => (slots && slots[0] ?
            slots[0] : <NoSlot {...props} />
        )}
    </Slot>,
];

export default MoreInfoPage;



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/MoreInfoPage.js